import { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './termSelect.module.scss';

export const TermSelect = memo(
  ({ className, titleClassName, title, options, termId, onChange, firstPaddingLeft, otherPaddingLeft }) => {
    // firstPaddingLeft, otherPaddingLeftはおまかせプランモーダル表示時に、左と右のpaddingを設定できるように追加したprops
    // 設定しないとき、default値が40で、他の画面に影響ないことを確認しました。
    return (
      <div className={classNames(styles.container, className)}>
        <div className={classNames(styles.title, titleClassName)}>{title ?? ''}</div>
        <div
          className={styles.buttons}
          style={{
            '--first-padding-left': `${firstPaddingLeft}px`,
            '--other-padding-left': `${otherPaddingLeft}px`,
          }}
        >
          {options.map(({ label, value }) => (
            <div key={value}>
              <div
                role="button"
                aria-hidden
                onClick={() => onChange(value)}
                className={classNames(styles.button, { [styles.active]: value === termId })}
              >
                {label}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  },
);

TermSelect.propTypes = {
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  title: PropTypes.string,
  termId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  onChange: PropTypes.func,
  firstPaddingLeft: PropTypes.number,
  otherPaddingLeft: PropTypes.number,
};

TermSelect.defaultProps = {
  className: undefined,
  titleClassName: undefined,
  title: undefined,
  termId: undefined,
  options: undefined,
  onChange: undefined,
  firstPaddingLeft: 10,
  otherPaddingLeft: 40,
};
